import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/openText-thumbnail.png"

export function Index() {
  return (
    <Layout
      title="African Tech Summit Hit a 50% Advocacy Rate — 10x the Industry Average"
      description="That’s 10x higher than the industry average and proof that attendee-driven promotion doesn’t have to be an afterthought."
      metaImage={ThumbnailImage}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "African Tech Summit", url: "/case-study/african-tech-summit/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "African Tech Summit Hit a 50% Advocacy Rate - 10x the Industry Average",
            "description": "That’s 10x higher than the industry average and proof that attendee-driven promotion doesn’t have to be an afterthought.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-06-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.AFRICAN_TECH_SUMMIT} />
    </Layout>
  )
}

export default Index
